// Required dependencies
import 'jquery';
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
// Assets
// These assets are extracted to [id].bundle.css using MiniCssExtractPlugin, see more on webpack.config.js
//import 'bootstrap/dist/css/bootstrap.css';
import './theme/style.css';

// UI tweaks
//import './ui/naja';

$(function () {
    const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')

    let popoverList = [];

    const hideAll = () => {
        popoverList.forEach(popover => {
            popover.hide();
        })
    }

    popoverTriggerList.forEach(function (popoverTriggerEl) {
        const popover = new bootstrap.Popover(popoverTriggerEl, {
            container: 'body',
            trigger: 'manual',
            html: true,
        });


        popoverTriggerEl.addEventListener('mouseenter', function () {
            popover.show();
            let popoverEl = document.querySelector('.popover')
            popoverEl.addEventListener('mouseleave', function () {
                hideAll();
            });
        }
        )
        popoverTriggerEl.addEventListener('mouseleave', function () {
            let interval = setInterval(function () {

                if (!document.querySelectorAll('.popover:hover').length) {
                    if (!document.querySelectorAll('[data-bs-toggle="popover"]:hover').length) {
                        hideAll();
                        clearInterval(interval);
                    }

                }

            }, 500);
        }
        )

        popoverList.push(popover);
    });
})


